import { render, staticRenderFns } from "./SpecificTradeLaw.vue?vue&type=template&id=7dfefaaa&scoped=true&"
import script from "./SpecificTradeLaw.vue?vue&type=script&lang=js&"
export * from "./SpecificTradeLaw.vue?vue&type=script&lang=js&"
import style0 from "./SpecificTradeLaw.vue?vue&type=style&index=0&id=7dfefaaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfefaaa",
  null
  
)

export default component.exports